import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "DocumentTotal" }
const _hoisted_2 = { class: "DocumentTotal-left" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "DocumentTotal-right" }
const _hoisted_6 = {
  key: 0,
  class: "DocumentTotal__row"
}
const _hoisted_7 = { class: "DocumentTotal-left" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 1,
  class: "DocumentTotal__row"
}
const _hoisted_11 = { class: "DocumentTotal-left" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "DocumentTotal-right" }
const _hoisted_15 = {
  key: 2,
  class: "DocumentTotal__row DocumentTotal__row--big"
}
const _hoisted_16 = { class: "DocumentTotal-left" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "DocumentTotal-right" }

import { PropType, computed } from "vue";
import { Document, Client, Line } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentTotal',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
    client: {
        type: Object as PropType<Client>,
        required: true,
    },
    lines: {
        type: Array as PropType<Line[]>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const vatShifted = computed(() => props.client.eu);

const getTotal = (multiplier: number) => {
    let total = 0;
    for (let documentLine of props.lines) {
        if (documentLine.lineType === "count") {
            total += documentLine.rate * documentLine.hours;
        } else if (documentLine.lineType === "amount") {
            total += Number(documentLine.amount);
        }
    }
    total *= multiplier;
    total = Math.ceil(100 * total) / 100;
    return total;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ 'DocumentTotal__row--big': vatShifted.value }, "DocumentTotal__row"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.document.english)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Total"))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, "Totaal"))
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(getTotal(1)) + " " + _toDisplayString(__props.document.currency), 1)
    ], 2),
    (vatShifted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (__props.document.english)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Vat shifted to " + _toDisplayString(__props.client.vat), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, "BTW verlegd naar " + _toDisplayString(__props.client.vat), 1))
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "DocumentTotal-right" }, null, -1))
        ]))
      : _createCommentVNode("", true),
    (!vatShifted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (__props.document.english)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " VAT  "))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, " BTW  ")),
            _createTextVNode(" " + _toDisplayString(__props.document.vat) + "% ", 1)
          ]),
          _createElementVNode("div", _hoisted_14, _toDisplayString(getTotal(__props.document.vat / 100)) + " " + _toDisplayString(__props.document.currency), 1)
        ]))
      : _createCommentVNode("", true),
    (!vatShifted.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (__props.document.english)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _cache[1] || (_cache[1] = [
                  _createElementVNode("b", null, "Total Amount", -1),
                  _createTextVNode("   ")
                ])))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, _cache[2] || (_cache[2] = [
                  _createElementVNode("b", null, "Te betalen", -1),
                  _createTextVNode("  ")
                ])))
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("b", null, _toDisplayString(getTotal(1 + __props.document.vat / 100)) + " " + _toDisplayString(__props.document.currency), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})